import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

import classnames from "classnames";

import "./Teaser.scss";

import Checkbox from "../Checkox/Checkbox.js";
import Button from "../Button/Button.js";

import GeoView from "../GeoView/GeoView";

import CrossIcon from "!svg-inline-loader!./images/cross.svg";
import CheckIcon from "!svg-inline-loader!./images/check.svg";

import RssIcon from "!svg-inline-loader!./images/rss.svg";
import PaymentIcon from "!svg-inline-loader!./images/payment.svg";

import SvgInline from "../SvgInline";

import DeviceTarget from "./DeviceTarget";
import MainTeaserButtons from "./MainTeaserButtons";
import TeaserPayment from "./TeaserPayment";
import ActiveUntil from "./ActiveUntil";
import StatTable from "./StatTable";

import PayoutStatus from "./PayoutStatus/PayoutStatus";

import StubImage from "./StubImage";

import Chart from "./Chart";
import RejectReasons from "./RejectReasons";

import Tests from "./Tests";

import { payoutStatus, teaserStatus } from "../../constants";

import IfPermission from "../../components/IfPermission";
import * as perm from "../../utils/perm";

import { campaignDashStat } from "../../utils/urls";
import formatDate from "../../utils/formatDate";
import Select from "../Select/Select";
import useGlobals from "../../hooks/useGlobals";

function cutDesc(desc) {
  let result = desc.replace(/(\.\.\.)$/, "");
  result = result.slice(0, 160) + "...";
  return result;
}

const Teaser = ({
  teaser,
  payment,
  onPaymentSelect,
  onGradeChange,
  checked,
  onCheckChange,
  loading,
  onStatusChange,
  onReloadClick,
  onCpcChange,
  cpcError,
  cpcMode,
  onCpcModeChange,
  onShowTypeChange,
  showUrl,
  showOt,
  onMpaaRatingChange,
  showDisclaimer
}) => {
  const globals = useGlobals();

  const handleCheckChange = e => {
    onCheckChange({ tid: teaser.id, checked: e.target.checked });
  };

  const handleStatusChange = status => {
    onStatusChange({ tid: teaser.id, status });
  };

  const handleShowTypeChange = type => {
    onShowTypeChange({ tid: teaser.id, type });
  };

  const handleReloadClick = () => {
    onReloadClick({ tid: teaser.id });
  };

  const handleCpcChange = cpc => {
    onCpcChange({ tid: teaser.id, cpc });
  };

  const handlePaymentSelect = (payoutStatus, reasons) => {
    onPaymentSelect({
      tid: teaser.id,
      payoutStatus,
      payoutStatusOld: teaser.payout_status,
      reasons
    });
  };

  const handleGradeChange = gradeStatus => {
    onGradeChange({
      tid: teaser.id,
      gradeStatus,
      gradeStatusOld: teaser.grade_status
    });
  };

  const addDate = formatDate(teaser.add_date);
  const editDate = formatDate(teaser.edit_date);

  const canViewPayoutStatus = (permissions, user) => {
    return (
      perm.canViewPayoutStatusAll(permissions) ||
      (teaser.user &&
        perm.canViewPayoutStatus(permissions) &&
        teaser.user.id == user.id)
    );
  };

  const mpaaRatingOptions =
    globals?.mpaa_rating?.map(rating => {
      return {
        label: rating.name,
        value: rating.id
      };
    }) ?? [];

  return (
    <div
      className={classnames("teaser", {
        teaser__loading: loading,
        teaser__new: teaser.isNew
      })}
    >
      <div className="teaser__image-col">
        <div className="teaser__image-wrapper">
          {teaser.image ? <img src={teaser.image} /> : <StubImage />}

          <div className="teaser__image-cut-top" />
          <div className="teaser__image-cut-bottom" />
        </div>
        <div className="teaser__id-wrapper">
          <Checkbox
            id={`teaser-${teaser.id}`}
            checked={checked}
            onChange={handleCheckChange}
          >
            ID {teaser.id}
          </Checkbox>
          <div className="teaser__oz">
            {teaser.from_aggregator && <SvgInline src={RssIcon} />}
            <IfPermission checker={canViewPayoutStatus}>
              <PayoutStatus
                status={teaser.payout_status}
                gradeStatus={teaser.grade_status}
                reasons={teaser.payout_reasons}
                showReasons={teaser.payout_reasons.length != 0}
              />
            </IfPermission>
          </div>
        </div>
      </div>

      <div className="teaser__title-col">
        <div className="teaser__title-col-wrapper">
          <div className="teaser__title">
            <a
              target="_blank"
              href={`https://ex.24smi.info/top/in/${teaser.id}/`}
            >
              {showOt ? teaser.original_title : teaser.title}
            </a>
          </div>

          <div className="teaser__campaign-name-wrapper">
            <a
              className="teaser__campaign-name"
              href={campaignDashStat(teaser.campaign.id)}
              target="_blank"
            >
              {teaser.campaign.name}
            </a>

            <span className="teaser__campaing-cat-divider">|</span>

            <span className="teaser__cat-name">
              {teaser.category && teaser.category.name}
            </span>
          </div>

          {showDisclaimer && (
            <p className="teaser__desc">{teaser.disclaimer}</p>
          )}

          <div className="teaser__desc">
            {showUrl ? (
              <a href={teaser.url} target="_blank">
                {teaser.url}
              </a>
            ) : (
              cutDesc(teaser.desc)
            )}
          </div>

          <div className="teaser__buttons">
            {payment ? (
              <TeaserPayment
                onSelect={handlePaymentSelect}
                teaser={teaser}
                onGradeChange={handleGradeChange}
              />
            ) : (
              <div>
                <div
                  style={{
                    marginBottom: 6
                  }}
                >
                  <Select
                    value={teaser.mpaa_rating}
                    placeholder={"Выбор рейтинга MPA"}
                    options={mpaaRatingOptions}
                    onSelect={onMpaaRatingChange}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center"
                  }}
                >
                  <MainTeaserButtons
                    teaser={teaser}
                    onStatusClick={handleStatusChange}
                    onReloadClick={handleReloadClick}
                    onCpcChange={handleCpcChange}
                    cpcError={cpcError}
                    cpcMode={cpcMode}
                    onCpcModeChange={onCpcModeChange}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="teaser__author">
          {teaser.user && (
            <React.Fragment>
              Автор:{" "}
              <span className="teaser__author-name">
                {teaser.user && (teaser.user.name || teaser.user.id)}
              </span>
              {teaser.stopped_by && (
                <React.Fragment>
                  <span className="teaser__stopped-by-divider">|</span>
                  Остановил:{" "}
                  <span className="teaser__stopped-by">
                    {teaser.stopped_by.name || teaser.stopped_by.id}
                  </span>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </div>
      </div>

      <div className="teaser__meta-col">
        <div className="teaser__meta-row">
          <span>Создан: </span>
          <span>{addDate}</span>
        </div>

        <div className="teaser__meta-row">
          <span>Редакт: </span>
          <span>{editDate}</span>
        </div>

        {/*<div className="teaser__meta-row">
                    <span>В открутке: </span>
                    <span>10 часов</span>
                    </div>*/}

        <ActiveUntil date={teaser.active_until} />

        <IfPermission checker={perm.canViewGeo}>
          <div className="teaser__meta-row">
            <span>География: </span>
            <GeoView
              geo={teaser.campaign.geo}
              isExclude={teaser.campaign.geo_exclude}
            />
          </div>
        </IfPermission>

        <IfPermission checker={perm.canViewDevice}>
          <div className="teaser__device-target-wrapper">
            <DeviceTarget
              mobile_enabled={teaser.campaign.mobile_enabled}
              desktop_enabled={teaser.campaign.desktop_enabled}
            />
          </div>
        </IfPermission>
      </div>

      <div className="teaser__stat-col">
        <StatTable teaser={teaser} onShowTypeChange={handleShowTypeChange} />

        <div className="teaser__ministat">
          <IfPermission checker={perm.canViewImportance}>
            <span className="teaser__ministat-item">
              Доля: {teaser.importance ? teaser.importance : "-"}%
            </span>
          </IfPermission>

          <IfPermission checker={perm.canViewKpi}>
            <span
              className={classnames("teaser__ministat-item", {
                red: teaser.kpi_danger
              })}
            >
              KPI: {teaser.stat.kpi || "-"}
            </span>
          </IfPermission>

          <span className="teaser__ministat-item">
            <Tests tests={teaser.tests} />
          </span>
        </div>

        {teaser.published == teaserStatus.reject ? (
          <RejectReasons reasons={teaser.reject_reasons} />
        ) : (
          <Chart data={teaser.chart_data} />
        )}
      </div>
    </div>
  );
};

Teaser.propTypes = {
  teaser: PropTypes.object.isRequired,
  payment: PropTypes.bool
};

Teaser.defaultProps = {
  payment: false,
  showUrl: false
};

export default Teaser;
